<template>
    <div class="upgrade-lifetime-box box">
        <h2>Add more sites to your subscription</h2>
        <p class="info-text">
To add more sites to your subscription you need to sign in to a Pro Plan.
</p>
        <user-payment-setup
            :active-sites="+activeSites"
            :skip-registration="true"
            :upgrade-lifetime="true"
            :process-lifetime-upgrade="processLifetimeUpgrade"
            @process-to-step="upgradeSuccess"
        >
            <template v-slot:billing-info-title>
                Enter your billing info
            </template>
        </user-payment-setup>
        <div class="lifetime-user-upgrade-controls upgrade-container">
            <div class="payment-details">
                <p class="section-title">
                    Payment Overview
                </p>
                <div
                    class="overview-line upgrade-line line-with-buttons"
                >
                    <p class="upgrade-label">
                        # of sites
                    </p>
                    <div class="input flex">
                        <div
                            class="number-handler"
                            @click="decreaseSites"
                        >
                            <i class="far fa-minus" />
                        </div>
                        <input
                            :value="activeSites"
                            :style="{ width: inputWidth }"
                            class="counter"
                            type="text"
                            @input="activeSites = +$event.target.value"
                        >
                        <div
                            class="number-handler"
                            @click="increaseSites"
                        >
                            <i class="far fa-plus" />
                        </div>
                    </div>
                </div>
                <div
                    v-if="plan.id"
                    class="overview-line upgrade-line line-with-buttons"
                >
                    <p class="upgrade-label">
                        Your {{ toLower(plan.nickname) }} payment
                    </p>
                    <div class="site-price">
                        <template v-if=" 'month' === plan.interval">
                            {{ plan | billingPlanFilter( activeSites ) }}
                        </template>
                        <template v-else>
                            {{ usdFormatter( plan.amount * activeSites ) }}
                        </template>
                    </div>
                </div>
            </div>
            <base-submit-button
                class="btn btn-update"
                :disabled="disabled"
                :loading="formProcessing"
                @click="processUpgrade"
            >
            Save changes
            </base-submit-button>
        </div>
    </div>
</template>

<script>
import { toLower } from 'lodash';
import usdFormatter from '@/utils/usdFormatter';
import UserPaymentSetup from '@/components/Register/UserPaymentSetup';
import toasts from '@/mixins/toasts';
import { mapActions } from 'vuex';

export default {

    components: {
        UserPaymentSetup,
    },
    mixins: [toasts],

    data: () => ({
        formProcessing: false,
        disabled: false,
        processLifetimeUpgrade: false,
        activeSites: 1,
        plan: {},
    }),

    computed: {
        /**
         * Calculates input width
         *
         * @returns { string } Input width value
         */
        inputWidth() {
            const sitesLength = this.activeSites.toString().length;

            return (sitesLength + 1) + 'ch';
        },
    },

    watch: {
        /**
         * Active sites change watcher
         */
        activeSites() {
            if ('' === this.activeSites || '0' >= this.activeSites) {
                this.activeSites = 1;
            }
        },
    },

    /**
     * Created hook
     */
    created() {
        this.$event.$on('planDetailsChange', (plan) => {
            this.plan = { ...this.plan, ...plan };
        });

        this.$event.$on('upgradeLifetimeError', () => {
            this.formProcessing = false;
            this.disabled = false;
        });
    },

    /**
     * Before destroy hook
     */
    beforeDestroy() {
        this.$event.$off('planDetailsChange');
        this.$event.$off('upgradeLifetimeError');
    },

    methods: {
        ...mapActions(['updateUser']),

        toLower,
        usdFormatter,

        /**
         * Handles upgrade sucess
         */
        upgradeSuccess() {
            this.formProcessing = false;
            this.disabled = false;

            this.toastSuccess({
                message: {
                    title: 'Your Account has been upgraded to Fusebox Pro Plan',
                },
            });
        },

        /**
         * Increse sites counter
         *
         */
        increaseSites() {
            this.activeSites++;
        },

        /**
         * Decrease sites counter
         *
         */
        decreaseSites() {
            if (1 < this.activeSites) {
                this.activeSites--;
            }
        },

        /**
         * Process lifetime user upgrade
         */
        processUpgrade() {
            this.formProcessing = true;
            this.disabled = true;
            this.processLifetimeUpgrade = true;
        },

    },
};
</script>
